import { call, put, take, takeEvery, takeLatest } from "redux-saga/effects";
import { GET_USER_REDEEMS, GET_USER_REFERRAL, SEND_REFERRAL_MAIL } from "./actionType";
import { getUserRedeemsFail, getUserRedeemsSuccess, getUserReferralsFail, getUserReferralsSuccess, sendReferralMailFail, sendReferralMailSuccess } from "./actions";
import { getUserRedeemsApi, getUserReferralsApi, sendReferralMailApi } from "helpers/backend_helper";
import moment from 'moment';

function* getUserReferrals({ payload: { data, callback } }) {
  try {
    const response = yield call(getUserReferralsApi, data);

    if (response.status === "failure") {
      return yield put(getUserReferralsFail(response.message));
    }
    response.data.map((tr) => {
      let localtime = moment.unix(tr.created_date).local()
      tr.created_date = localtime.format('YYYY-MM-DD HH:mm:ss');
      return tr;
    })

    callback && callback(response);
    yield put(getUserReferralsSuccess(response));
  } catch (error) {
    yield put(getUserReferralsFail(""));
  }
}

function* sendReferralMail({ payload: { data, callback } }) {
  try {
    const response = yield call(sendReferralMailApi, data);

    if (response.status === "failure") {
      callback && callback(response);
      return yield put(sendReferralMailFail(response.message));
    }

    callback && callback(response);
    yield put(sendReferralMailSuccess(response));
  } catch (error) {
    yield put(sendReferralMailFail(error));
  }
}

function* getUserRedeems({ payload: { data, callback } }) {
  try {
    const response = yield call(getUserRedeemsApi, data);

    if (response.status === "failure") {
      return yield put(getUserRedeemsFail(response.message));
    }
    response.data.map((tr) => {
      let localtime = moment.unix(tr.created_date).local()
      tr.created_date = localtime.format('YYYY-MM-DD HH:mm:ss');
      return tr;
    })

    callback && callback(response);
    yield put(getUserRedeemsSuccess(response));
  } catch (error) {
    yield put(getUserRedeemsFail(error));
  }
}

function* OwnersSaga() {
  yield takeEvery(GET_USER_REFERRAL, getUserReferrals);
  yield takeEvery(SEND_REFERRAL_MAIL, sendReferralMail);
  yield takeEvery(GET_USER_REDEEMS, getUserRedeems);

}

export default OwnersSaga;
